
import { defineComponent, ref } from 'vue';

export default defineComponent({
    name: "BookingOverviewNoQuery",
    props: {
        pageUrls: {
            type: Object,
            required: true
        },
        pageTexts: {
            type: Object,
            required: true
        }
    },
    setup() {
        const isActive = ref(false);
        const tabletActive = ref(false);

        const hotelName = document.getElementsByTagName("H1")[0].innerHTML;

        const clickDatePicker = () => {
            document.getElementById('searchDatepickerBtn')?.click();
        }

        const clickAirportPicker = () => {
            document.getElementById('searchAirportBtn')?.click();
        }

        const clickTravellersPicker = () => {
            document.getElementById('searchTravellersBtn')?.click();
        }

        return {
            isActive,
            tabletActive,
            hotelName,
            clickDatePicker,
            clickAirportPicker,
            clickTravellersPicker
        }
    },
})
